import dynamic from "next/dynamic";
import Image from "next/image";
import { useState } from "react";

import {
  setUserAdsCookies,
  setUserCookies,
  setUserPerformanceCookies,
  setUserPersonalizationCookies,
} from "../../api/utils/userCookies/userCookies.util";
import { translationsContent } from "../../localization/translations";
import { useLanguage } from "../../store/lang.context";
import imageLoader from "../../utils/loader";
import { translate } from "../../utils/translate";
import DarkButton from "../ui/button/DarkButton";
import DynamicModal from "../ui/modal/DynamicModal";
import classes from "./popup.module.scss";

const CookiesSettings = dynamic(
  () => import("../layout/Footer/Legals/CookiesSettings"),
  { ssr: false }
);

interface Props {
  onClose: () => void;
}

const UserCookiesPopup = ({ onClose }: Props) => {
  const [open, setIsOpen] = useState<boolean>(false);

  const { language } = useLanguage();

  const handleOnClick = (accept: boolean) => {
    setUserCookies(accept);
    setUserAdsCookies(accept ? "ACCEPTED" : "REFUSED");
    setUserPerformanceCookies(accept ? "ACCEPTED" : "REFUSED");
    setUserPersonalizationCookies(accept ? "ACCEPTED" : "REFUSED");
    onClose();
  };

  const handleOnMiddleClick = () => {
    setIsOpen(true);
  };

  return (
    <>
      <DynamicModal onClose={onClose} noPadding={true}>
        <div className={classes.container}>
          <Image
            loader={imageLoader}
            src={"eat-salad-transparent.png"}
            alt="Eat Salad Logo"
            width={180}
            height={42}
          />
          <h2>
            {translate(translationsContent, "userCookiesPopupTitle", language)}
          </h2>
          <div className={classes.divider}></div>
          <div className={classes.descriptionContainer}>
            <p className={classes.description}>
              {translate(
                translationsContent,
                "userCookiesPopupDescription",
                language
              )}
            </p>
            <p
              className={classes.link}
              onClick={() => {
                handleOnMiddleClick();
              }}
            >
              {translate(translationsContent, "userCookiesPopupLink", language)}
            </p>
            <div className={classes.buttons}>
              <div className={classes.button}>
                <DarkButton
                  label={translate(
                    translationsContent,
                    "userCookiesPopupReject",
                    language
                  )}
                  onClick={() => {
                    handleOnClick(false);
                  }}
                />
              </div>
              <div className={classes.button}>
                <DarkButton
                  label={translate(
                    translationsContent,
                    "userCookiesPopupMore",
                    language
                  )}
                  onClick={() => {
                    handleOnMiddleClick();
                  }}
                />
              </div>
              <div className={classes.button}>
                <DarkButton
                  label={translate(
                    translationsContent,
                    "userCookiesPopupAccept",
                    language
                  )}
                  onClick={() => {
                    handleOnClick(true);
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </DynamicModal>
      {open && <CookiesSettings setIsOpen={setIsOpen} />}
    </>
  );
};

export default UserCookiesPopup;
